'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var classView = function classView() {
  return import('@/page/dx-class');
};
var classList = function classList() {
  return import('@/page/dx-class/class-list');
};
var classDetail = function classDetail() {
  return import('@/page/dx-class/class-detail');
};
var classResourse = function classResourse() {
  return import('@/page/dx-class/class-menu/resourse');
};
var classMaillist = function classMaillist() {
  return import('@/page/dx-class/class-menu/maillist');
};
var classAssessment = function classAssessment() {
  return import('@/page/dx-class/class-menu/assessment');
};
var classAlbum = function classAlbum() {
  return import('@/page/dx-class/class-menu/album');
};
var classCertificate = function classCertificate() {
  return import('@/page/dx-class/class-menu/certificate');
};
var certificateDetail = function certificateDetail() {
  return import('@/page/dx-class/class-menu/certificate-detail');
};
var feedback = function feedback() {
  return import('@/page/dx-feedback');
};
var communicationDetail = function communicationDetail() {
  return import('@/page/dx-class/class-detail/communication-detail');
};
var leaveAudit = function leaveAudit() {
  return import('@/page/dx-class/leave-audit');
};
var diningSituation = function diningSituation() {
  return import('@/page/dx-class/dining-situation');
};

exports.default = [{
  path: '/dxClass',
  name: 'dxClass',
  component: classView,
  children: [{
    path: 'class-list',
    name: 'dx-class-list',
    component: classList
  }, {
    path: 'class-detail',
    name: 'dx-class-detail',
    component: classDetail
  }, {
    path: 'class-assessment',
    name: 'dx-class-assessment',
    component: classAssessment
  }, {
    path: 'class-resourse',
    name: 'dx-class-resourse',
    component: classResourse
  }, {
    path: 'class-album',
    name: 'dx-class-album',
    component: classAlbum
  }, {
    path: 'class-maillist',
    name: 'dx-class-maillist',
    component: classMaillist
  }, {
    path: 'class-certificate',
    name: 'dx-class-certificate',
    component: classCertificate
  }, {
    path: 'certificate-detail',
    name: 'dx-certificate-detail',
    component: certificateDetail
  }, {
    path: 'dx-class-feedback',
    name: 'dx-class-feedback',
    component: feedback
  }, {
    path: 'communication-detail',
    name: 'communication-detail',
    component: communicationDetail
  }, {
    path: 'leave-audit',
    name: 'leave-audit',
    component: leaveAudit
  }, {
    path: 'dining-situation',
    name: 'dining-situation',
    component: diningSituation
  }]
}];